<ng-container *ngIf="content | translate; ">

    <section class="legal-page-container" [innerHTML]="content | translate">

    </section>
</ng-container>
<ng-container *ngIf="isNotFound">
    <app-no-route></app-no-route>
</ng-container>